import GoalCompletionCircle from "./GoalCompletionCircle"
export default GoalCompletionCircle
